import React, { useContext, useState } from "react";
import { withRouter } from "react-router-dom";

import Button from '../../theme/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { InputAdornment, IconButton } from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

import Input from "../../theme/CustomMUI/Input";
import Axios from "axios";
import { toast } from "react-toastify";
import MaskedInput from "../../theme/CustomMUI/MaskedInput";
import { Alert } from "@material-ui/lab";
import AppContext from "../../context/store";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import styled, { keyframes } from "styled-components";
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage: `url(${require('../../assets/images/unauth_image.jpg')})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));


const ForgotPassIndex = (props) => {
  const context = useContext(AppContext);
  const history = useHistory();
  const classes = useStyles();

  const [smsRequestForm, setSmsRequestForm] = useState({
    phone: null
  })


  const [newPassWithSMSCodeForm, setNewPassWithSMSCodeForm] = useState({
    code: null,
    password: null
  })

  const [step, setStep] = useState(1)
  const [showPassword, setShowPassword] = useState(false)
  const [passwordValidation, setPasswordValidation] = useState({
    length: false,
    hasLetter: false,
    hasNumber: false,
    hasSpecialChar: false,
    isValid: false
  })

  // Şifre validasyon fonksiyonu
  const validatePassword = (password) => {
    if (!password) {
      setPasswordValidation({
        length: false,
        hasLetter: false,
        hasNumber: false,
        hasSpecialChar: false,
        isValid: false
      })
      return
    }

    const length = password.length >= 6 && password.length <= 12
    const hasLetter = /[a-zA-Z]/.test(password)
    const hasNumber = /[0-9]/.test(password)
    const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)
    const isValid = length && hasLetter && hasNumber && hasSpecialChar

    setPasswordValidation({
      length,
      hasLetter,
      hasNumber,
      hasSpecialChar,
      isValid
    })
  }


  const getSMSCode = () => {
    Axios
      .post(`${context.api_endpoint}/staff/reset/password/cd`, {
        ...smsRequestForm
      })
      .then(response => {
        setSmsRequestForm({ phone: null });
        if (response.status === 201) {
          toast.success(context.t(`forgotPass.verificationSuccessfullySentToast`));
          setStep(2)
        } else {
          toast.error(context.t(`forgotPass.verificationErrorToast`));
        }
      })
      .catch(() => {
        toast.error(context.t(`forgotPass.verificationErrorToast`));
      })
  }

  const resetPass = () => {
    Axios
      .post(`${context.api_endpoint}/staff/reset/password`, {
        ...newPassWithSMSCodeForm
      })
      .then(response => {
        if (response.status === 201) {
          toast.success(context.t(`forgotPass.passwordSuccessfullyChangedToast`));
          history.push('/login')
        } else {
          toast.error(context.t(`forgotPass.warningStatusToast`))
        }
      })
      .catch((error) => {
        if (error.response?.data?.data) {
          toast.error(error.response.data.data);
        } else {
          toast.error(context.t(`forgotPass.warningStatusToast`));
        }
      })

  }



  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={false} sm={4} md={8} className={classes.image} />
      <Grid item xs={12} sm={8} md={4} component={Paper} elevation={6} square>
        <div className={`${classes.paper} pt-5`}>

          <Typography component="h1" variant="h5" className="mb-0"><b>{context.app.NAME}</b></Typography>
          <Typography component="h1" variant="h6" className="mb-0">{context.t(`forgotPass.title`)}</Typography>

          <Alert severity="info" fullWidth className="mt-2 mb-2">
            <b>{context.t(`forgotPass.stepText`)}: {step}/2</b><br />
            {step === 1 && context.t(`forgotPass.firstStepText`)}
            {step === 2 && context.t(`forgotPass.secondStepText`)}
          </Alert>

          <form className={classes.form} noValidate onSubmit={e => e.preventDefault()} autoComplete="off">
            {step === 1 &&
              <>
                {process.env.APP_NAME === "management" ? (
                  <Input
                    required
                    autoComplete="off"
                    label={context.t(`register.staffMailInputLabel`)}
                    onChange={e => setSmsRequestForm({ ...smsRequestForm, phone: e.target.value })}
                  />
                ) : (
                  <MaskedInput
                    required
                    label={context.t(`forgotPass.phoneInputLabel`)}
                    maskChar={""}
                    mask="999 999 9999"
                    startAdornment="0"
                    value={smsRequestForm.phone !== null ? smsRequestForm.phone : ''}
                    placeholder="500 000 0000"
                    onChange={e => setSmsRequestForm({ ...smsRequestForm, phone: e.target.value.substring(0, 1) === "5" && e.target.value.replace(/\s/g, "") })}
                  />
                )}

                <Button
                  className="mt-1"
                  title={context.t(`forgotPass.continueButtonTitle`)}
                  type="submit"
                  size="lg"
                  fullWidth
                  textColor="white"
                  backgroundColor="primary"
                  onClick={() => getSMSCode()}
                />

                <Button
                  className="mt-1"
                  title={context.t(`forgotPass.backToHomeButtonTitle`)}
                  type="submit"
                  size="lg"
                  fullWidth
                  textColor="primary"
                  backgroundColor="white"
                  onClick={() => props.history.push('/login')}
                />
              </>
            }

            {step === 2 &&
              <>
                <PasswordWarningBox>
                  <WarningIcon>⚠️</WarningIcon>
                  <WarningText>
                    <strong>{context.t(`forgotPass.passwordRequirementsWarning`)}</strong><br />
                    {context.t(`forgotPass.passwordRequirementsDetails`)}<br />
                    <span style={{ fontSize: '14px', opacity: 0.9 }}>{context.t(`forgotPass.passwordRequirementsExample`)}</span>
                  </WarningText>
                </PasswordWarningBox>

                <Input
                  required
                  autoComplete="off"
                  label={context.t(`forgotPass.verificationCodeInputLabel`)}
                  onChange={e => setNewPassWithSMSCodeForm({ ...newPassWithSMSCodeForm, code: e.target.value })}
                />

                <Input
                  required
                  autoComplete="off"
                  label={context.t(`forgotPass.newPassInputLabel`)}
                  type={showPassword ? "text" : "password"}
                  onChange={e => {
                    const newPassword = e.target.value;
                    setNewPassWithSMSCodeForm({ ...newPassWithSMSCodeForm, password: newPassword });
                    validatePassword(newPassword);
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment>
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword(!showPassword)}
                          onMouseDown={(e) => e.preventDefault()}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                {newPassWithSMSCodeForm.password && (
                  <ValidationBox>
                    <ValidationItem isValid={passwordValidation.length}>
                      {passwordValidation.length ? <CheckIcon /> : <ClearIcon />} {context.t(`forgotPass.validationLength`)}
                    </ValidationItem>
                    <ValidationItem isValid={passwordValidation.hasLetter}>
                      {passwordValidation.hasLetter ? <CheckIcon /> : <ClearIcon />} {context.t(`forgotPass.validationLetter`)}
                    </ValidationItem>
                    <ValidationItem isValid={passwordValidation.hasNumber}>
                      {passwordValidation.hasNumber ? <CheckIcon /> : <ClearIcon />} {context.t(`forgotPass.validationNumber`)}
                    </ValidationItem>
                    <ValidationItem isValid={passwordValidation.hasSpecialChar}>
                      {passwordValidation.hasSpecialChar ? <CheckIcon /> : <ClearIcon />} {context.t(`forgotPass.validationSpecialChar`)}
                    </ValidationItem>
                  </ValidationBox>
                )}

                <Button
                  className="mt-1"
                  title={context.t(`forgotPass.updatePassButtonTitle`)}
                  type="submit"
                  size="lg"
                  fullWidth
                  textColor="white"
                  backgroundColor="primary"
                  onClick={() => resetPass()}
                />
              </>
            }
          </form>
        </div>
      </Grid>
    </Grid>
  );
}

// Animasyonlar
const slideDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const pulse = keyframes`
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.4);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(220, 38, 38, 0);
  }
`;

// Styled Components
const PasswordWarningBox = styled.div`
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);
  animation: ${slideDown} 0.5s ease-out, ${pulse} 2s infinite;
  border: 2px solid rgba(255, 255, 255, 0.2);
`;

const WarningIcon = styled.div`
  font-size: 24px;
  line-height: 1;
  flex-shrink: 0;
  margin-top: 2px;
`;

const WarningText = styled.div`
  color: white;
  font-size: 15px;
  line-height: 1.6;
  
  strong {
    font-weight: 600;
    font-size: 16px;
  }
`;

const ValidationBox = styled.div`
  background: #f8f9fa;
  border-radius: 8px;
  padding: 12px 16px;
  margin-top: 12px;
  margin-bottom: 12px;
  border: 1px solid #e5e7eb;
`;

const ValidationItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
  font-size: 14px;
  color: ${props => props.isValid ? '#10b981' : '#ef4444'};
  font-weight: 500;
  transition: all 0.3s ease;
  
  &:before {
    content: '';
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: ${props => props.isValid ? '#10b981' : '#ef4444'};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: white;
    flex-shrink: 0;
  }
`;

export default withRouter(ForgotPassIndex);
